export const SET_VM_FETCHING_FLAG = "SET_VM_FETCHING_FLAG";
export const SET_VM_INSIGHTS_OVERVIEW = "SET_VM_INSIGHTS_OVERVIEW";
export const SET_VM_INSIGHTS_SERVER_LIST = "SET_VM_INSIGHTS_SERVER_LIST";
export const SET_VM_INSIGHTS_TIMELINE_DATA = "SET_VM_INSIGHTS_TIMELINE_DATA";